import { ReactNode } from "react"

export const Section = ({
  title,
  subtitle,
  description,
  children
}: {
  title: string,
  subtitle: string,
  description: string,
  children?: ReactNode
}) => {
  return (
    <div className="flex flex-row w-full overflow-hidden">
      <div className="flex flex-col items-start flex-[2] min-w-0">
        {title?.length ? (
          <h3 className="text-primary uppercase font-bold text-3xl leading-10 truncate">
            {title}
          </h3>
        ) : null}
        <h3 className="text-primary font-medium text-2xl truncate">{subtitle}</h3>
        <p className="text-secondary text-left text-base font-normal truncate">
          {description}
        </p>
      </div>
      <div className="flex-[3] pl-7 min-w-0">
        {children}
      </div>
    </div>
  )
}
